import React from 'react';
import Button from '../elements/button';

import './ProductCard.css';
import { useNavigate } from 'react-router-dom';


const ProductCard = ({ product, onAddToCart, convertPrice }) => {
    const navigate = useNavigate();
    const { name, price, images, description } = product;
    const primaryImage = images?.[0]?.image;
    const image = primaryImage || 'https://via.placeholder.com/150';
    return (
        <div className="product-card" onClick={()=> navigate(`/marketplace/product/${product.id}`)}>
            <div className="product-image">
                <img src={image} alt={name} />
            </div>
            <div className="product-info">
                <h3 className="product-title">{name}</h3>
                <p className="product-description">
                    {description.slice(0, 100)}...
                </p>
                <div className="product-footer">
                    <span className="product-price">
                        {convertPrice ? convertPrice(price) : `₦${price.toFixed(2)}`}
                    </span>
                    <Button
                        text="Add to Cart"
                        variant="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            onAddToCart(product);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProductCard;